/**
 * Locus Dental Care brand tokens.
 * Primary palette: dark navy blue (logo color #1d1b4d).
 */
export const BRAND = {
  name: 'Locus Dental Care',
  appName: 'Locus Dental Care - Stock',
  legalName: 'Lakshmi Organised Care and United Services Pvt. Ltd.',
  tagline: "Dr Ram's Dental Care & Maxillofacial center",
  since: 'Since 2002',
  website: 'https://www.locusdentalcare.com',
  contact: {
    phone: '044 23719464',
    emergency: '98401 44964',
    email: 'clinic@locusdentalcare.com',
    address: '58, 12th Avenue, Ashok Nagar, Chennai - 600083'
  },
  colors: {
    navy: '#1d1b4d',
    navyDark: '#15133d',
    navyLight: '#2a2868',
    navyMuted: '#4a4878',
    accent: '#3d3a7a',
    text: '#1a1a2e',
    textMuted: '#5c5c72',
    background: '#f4f5f9',
    surface: '#ffffff',
    border: '#e2e4ef',
    rowHover: '#eceef6',
    cardTint: '#f3f4fa'
  },
  fonts: {
    body: '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  }
};

export default BRAND;
